import { SELF_TRANSFER_BANNER_VARIANTS } from '@web-platform/shared-universal-constants/src/booking/selfTransfer';

import { translate } from '../translate';

import type { SelfTransferBannerVariant } from '@web-platform/shared-universal-constants/src/booking/selfTransfer';

export const getSelfTransferBannerHeading = (
  selfTransferBannerVariant?: SelfTransferBannerVariant,
): string => {
  if (selfTransferBannerVariant === SELF_TRANSFER_BANNER_VARIANTS.ALL_OPTIONS) {
    return translate('ktxt_booking_all_options_self_transfer_title');
  }

  if (selfTransferBannerVariant === SELF_TRANSFER_BANNER_VARIANTS.SOME_OPTIONS) {
    return translate('ktxt_booking_some_options_self_transfer_title');
  }

  return translate('ktxt_booking_Warning_SelfTransfer_Title');
};
